<template>
  <div
    id="noauth-layout"
    class="container mx-auto h-full flex"
  >
    <slot />
  </div>
</template>

<style>
html, body, #__nuxt {
  height: 100%;
}
</style>
